export const TUBULAR_TYPE_COLUMN = 1
export const KPI_COLUMN = 2
export const RESTRICTED_PERFORMANCE_COLUMN = 7

export const PIPE_TAB_ACRONYM = 'PMT'
export const CONNECTION_TAB_ACRONYM = 'S2S'
export const ROP_TAB_ACRONYM = 'ROP'
